import axios from 'commonjs/axios';

export default class StripeHandler {
    constructor(stripe, cardElement, stripeVars, billingInfo, actions){
        this.stripeVars = stripeVars;
        this.cardElement = cardElement;
        this.stripe = stripe;
        this.billingInfo = billingInfo;
        this.actions = actions;
    }

    initPaymentFlow(){        
        this.startTransactionRequest().then( result => {
            if(result.data.success){                
                this.handleIntents(result.data.redirect_url, result.data.intent);           
            }else{
                this.actions.setErrors([{message: LWTranslate.get('payments.payment_failed')}]);
                this.actions.setLoading(false);
            }
            
        }).catch(errors =>{
            this.actions.setErrors([{message: LWTranslate.get('payments.payment_failed')}]);
            this.actions.setLoading(false);            
        });
    }

    startTransactionRequest(){
        return axios.post( `${server}billing/stripe/startTransaction`, this.getStripeVars() );        
    }

    finalizeTransactionRequest(paymentMethodId){        
        var postData = this.getStripeVars();
        postData['payment_method_id'] = paymentMethodId;
        return new Promise((resolve, reject) =>{
            axios.post(`${server}billing/stripe/finalizeTransaction`, postData).then( response => {
                if(response.data.success) {                    
                    //Check if there is refersion and cart in order to set the refersion cart
                    if(response.data.cartId && typeof window._refersion !== 'undefined'){
                        window._refersion(function(){ window._rfsn._addCart(response.data.cartId);});                            
                    }
                    if(response.data.intent){
                        return resolve({'redirectUrl':response.data.redirect_url, 'intent': response.data.intent });                            
                    } 
                    resolve({'redirectUrl': response.data.redirect_url});
                } else {                        
                    reject(response.data.errors);    
                }
            });
        }); 
    }

    handleIntents(redirectUrl, intent){        
        if(intent.object == 'setup_intent'){                
            this.handleSetupIntent(redirectUrl, intent);
        }else{
            this.handlePaymentIntent(redirectUrl, intent);    
        }
    }

    handleSetupIntent(redirectUrl, intent){
        this.stripe.handleCardSetup(
            intent.client_secret, this.cardElement, {
                payment_method_data: {
                    billing_details: this.getBillingInfo()
                }
            }
        ).then(result => {
            if (result.error) {
                this.actions.setErrors([{message: LWTranslate.get('payments.payment_failed')}]);
                this.actions.setLoading(false);                
            } else {
              // The setup has succeeded. Display a success message.
              //window.location.href = _this.finalUrl + '&token=' + result.setupIntent.payment_method;
              this.finalizeTransactionRequest(result.setupIntent.payment_method).then( result => {
                  // Throw error if intent has a status of requires_payment_method or requires_source
                  if (result.intent && ['requires_payment_method', 'requires_source'].indexOf(result.intent.status) !== -1) {
                    this.actions.setErrors([{message: LWTranslate.get('payments.payment_failed')}]);
                    this.actions.setLoading(false);
                    //   _this.setLoadingCardPaymentModal(false);
                  } else if(result.intent && ['requires_confirmation', 'requires_action', 'requires_source_action'].indexOf(result.intent.status) !== -1){
                    this.handleIntents(result.redirectUrl, result.intent);
                  } else if(result.intent){
                    this.startPollingTransaction(result.redirectUrl, result.intent.id);                                                
                  } else {
                    window.location.href = result.redirectUrl;
                  }                                            
                
              }).catch( errors => {
                    this.actions.setErrors(errors);
                    this.actions.setLoading(false);                
              });
            }                
        });
    }

    handlePaymentIntent(redirectUrl, intent){         
         this.stripe.handleCardPayment(
            intent.client_secret, this.cardElement,  {
                payment_method_data: {
                    billing_details: this.getBillingInfo()
                }
            }
        ).then(result => {
            if(result.error){
                this.actions.setErrors([{message: LWTranslate.get('payments.payment_failed')}]);
                this.actions.setLoading(false);                
            }else{
                if (result.paymentIntent && result.paymentIntent.status == 'succeeded'){                       
                    this.startPollingTransaction(redirectUrl, result.paymentIntent.id);                        
                }
            }
        });
    }

    startPollingTransaction(redirectUrl, intentId){        
        var counter = 0;
        var check = function(counter){
            if(counter > 10 ){
                window.location.href = redirectUrl;
                return;
            }
            setTimeout(()=>{                 
                counter++;
                axios.get(`${server}billing/stripe/transactionStatus/${intentId}`).then( response => {
                    if(response.data.success && response.data.found) {                                                       
                        window.location.href = redirectUrl;
                    } else {                 
                        check(counter);    
                    }
                });                
            }, 3000);
        }
        check(counter);        
    }

    getStripeVars(){
        return this.stripeVars;
    }

    getBillingInfo(){
        return this.billingInfo;
    }
}
